import React, { createContext, useContext, useEffect, useState } from 'react';
import { coreAPI } from '../services/api';

const SiteInfoContext = createContext(null);

export const useSiteInfo = () => {
  const context = useContext(SiteInfoContext);
  if (!context) {
    throw new Error('useSiteInfo must be used within SiteInfoProvider');
  }
  return context;
};

export const SiteInfoProvider = ({ children }) => {
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchSiteInfo = async () => {
      try {
        const response = await coreAPI.getSiteInfo();
        if (isMounted) {
          setSiteInfo(response.data);
        }
      } catch (err) {
        console.error('Failed to load site info', err);
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSiteInfo();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <SiteInfoContext.Provider value={{ siteInfo, loading, error }}>
      {children}
    </SiteInfoContext.Provider>
  );
};
